jQuery(document).ready(function($) {
  // Popup contact forms
  $('.form__favourite').each(function() {
    $(this).on('submit', function(e) {
      e.preventDefault()
      var $form = $(this)
      var formButton = $form.find('button')
      var formAction = $form.find('#favourite-action')
      var plotId = $form.find('#favourite-plot').val()
      formButton.addClass('plot__favourite--loading')
      if (formAction.val() === 'harron_submit_favourite_action') {
        $.post(
          $form.attr('action'),
          $form.serialize(),
          function(data) {
            if (!data.error) {
              formButton.removeClass('plot__favourite--loading')
              // Set the form action to unfavourite
              formAction.val('harron_submit_unfavourite_action')
              // Add the class for the SVG colour
              formButton.addClass('plot__favourite--favourite')
              $.event.trigger({
                type: 'harronFavouriteSuccess',
                plot: plotId,
                time: new Date(),
              })
            } else {
              formButton.removeClass('plot__favourite--loading')
              // The data has returned an error
              console.log('Somehow, you are not logged in...')
              $.event.trigger({
                type: 'harronFavouriteFail',
                plot: plotId,
                time: new Date(),
              })
            }
          },
          'json'
        ).fail(function() {
          formButton.removeClass('plot__favourite--loading')
          console.log('All errors. No idea why...')
          $.event.trigger({
            type: 'harronFavouriteFail',
            plot: plotId,
            time: new Date(),
          })
        })
      }
      if (formAction.val() === 'harron_submit_unfavourite_action') {
        $.post(
          $form.attr('action'),
          $form.serialize(),
          function(data) {
            if (!data.error) {
              formButton.removeClass('plot__favourite--loading')
              // Set the form action to unfavourite
              formAction.val('harron_submit_favourite_action')
              // Add the class for the SVG colour
              formButton.removeClass('plot__favourite--favourite')
              // Remove the card on My Harron page only
              $('.page-template-template-login-area #plot-' + plotId).hide()
              $.event.trigger({
                type: 'harronUnFavouriteSuccess',
                plot: plotId,
                time: new Date(),
              })
            } else {
              formButton.removeClass('plot__favourite--loading')
              // The data has returned an error
              console.log('Somehow, you are not logged in...')
              $.event.trigger({
                type: 'harronUnFavouriteFail',
                plot: plotId,
                time: new Date(),
              })
            }
          },
          'json'
        ).fail(function() {
          formButton.removeClass('plot__favourite--loading')
          console.log('All errors. No idea why...')
          $.event.trigger({
            type: 'harronUnFavouriteFail',
            plot: plotId,
            time: new Date(),
          })
        })
      }
    })
  })
})
